import accordion from "../../../../app/client/src/js/components/accordion.js"
import table from "../../../../app/client/src/js/components/table.js"
import video from "../../../../app/client/src/js/components/video.js"
import forms from "../../../../app/client/src/js/components/forms.js"
import accessibilityshim from "../../../../app/client/src/js/components/accessibility-shim"
import shielded from "../../../../app/client/src/js/components/shielded"
import pagehero from "./components/page-hero.js"
import menu from "./components/menu.js"
import mobileMenu from "./components/mobile-menu.js"
import pageOutline from "./components/page-outline.js"

document.addEventListener("DOMContentLoaded", function() {
  menu()
  table()
  video()
  accordion()
  forms()
  accessibilityshim()
  mobileMenu()
  pagehero()
  shielded()
  pageOutline()
})
